/*

  Usage:

  const Page = ({ items }) => {
    const containerRef = useRef(null)

    const { lastIndex } = useLimitedScroll({
      elementRef: containerRef,
      count: items.length,
      limit: 20,
      offsetBottom: 300,
    })

    const slicedItems = useMemo(() => childrenArray.slice(0, lastIndex), [ childrenArray, lastIndex ])

    return (
      <div ref={containerRef} className={s.overflowScroll}>
        {
          slicedItems.map((item, index) => (
            <div key={index}>
              {item}
            </div>
          )
        }
      </div>
    )
  }

  A hook is used to limit amount of children items, and add it by limited parts (equals to limit),
  when you scroll down and reach offsetBottom.
  It helps to decrease render time if we have to render large amount of child components (like notes or brands list)
  in the scrollable container
 */

import React, { useState, useCallback } from 'react'
import useEventListener from './useEventListener'


const useLimitedScroll = (props) => {
  const { count, limit = 20, offsetBottom = 300, elementRef } = props

  const [ lastIndex, setLastIndex ] = useState(limit)

  const handleScroll = useCallback(() => {
    const { scrollTop, scrollHeight, offsetHeight } = elementRef.current

    const scrollBottom = scrollHeight - scrollTop - offsetHeight

    if (scrollBottom < offsetBottom && count > lastIndex) {
      setLastIndex(lastIndex + limit)
    }
  }, [ count, limit, lastIndex, offsetBottom ])

  useEventListener('scroll', handleScroll, elementRef.current)

  return {
    lastIndex,
  }
}


export default useLimitedScroll
